const styles = theme => ({})

export default styles



// WEBPACK FOOTER //
// ./src/pages/Index/styles.js